import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { useAuth } from '../Login/useAuth';
import { setCurrentUser, setLogoutState } from 'redux/authentication/auth.actions';

import './logout.style.css';

const Logout = ({ currentUser, setCurrentUser, setLogoutState }) => {
  const auth = useAuth();

  useEffect(() => {
    if (currentUser) {
      setCurrentUser(null);
      setLogoutState(true);
    }
  }, []);

  const initiateLogout = () => {
    auth.removeToken();
    setLogoutState(false);
  };

  return (
    <>
      <div className='logout-background'>
        <div className='logout-box-container'>
          <h1 className='header'>Log out</h1>
          <h2>You have been logged out of the WPV application.</h2>
          <Link to='/admin' onClick={() => initiateLogout()}>Log in again.</Link>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({
  authentication: { authHeader, currentUser } }) => ({
    authHeader,
    currentUser
  });

const mapDispatchToProps = dispatch => ({
  setCurrentUser: user => dispatch(setCurrentUser(user)),
  setLogoutState: state => dispatch(setLogoutState(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);